import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { CamerasParamList } from '../../../typings/Params';
import DownloadTagsDropdown from '../../../components/cameras/DownloadTagsDropdown';
import DownloadUserDropdown from './DownloadUserDropdown';
import DownloadCameraDropdown from './DownoladCameraDropdown';

interface Props {
    filters: CamerasParamList['Downloads'];
    setFilters: React.Dispatch<React.SetStateAction<CamerasParamList['Downloads']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<CamerasParamList, 'Downloads'>>>();

    const [tagsIds, setTagsIds] = useState<number[]>(filters.tagsIds ?? []);
    const [userId, setUserId] = useState<number>(filters.userId ?? 0);
    const [userText, setUserText] = useState<string>('');
    const [cameraId, setCameraId] = useState<string>(filters.cameraId ?? '');
    const [cameraText, setCameraText] = useState<string>('');


    const handleCleanFilter = () => {
        setTextFilter('');
        setTagsIds([]);
        setUserId(0);
        setUserText('');
        setCameraId('');
        setCameraText('');


    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            tagsIds: tagsIds.length > 0 ? tagsIds : undefined,
            userId: userId !== 0 ? userId : undefined,
            cameraId: cameraId !== '' ? cameraId : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            tagsIds: tagsIds.length > 0 ? tagsIds : undefined,
            userId: userId !== 0 ? userId : undefined,
            cameraId: cameraId !== '' ? cameraId : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
            <DownloadTagsDropdown
                value={tagsIds}
                setValue={setTagsIds}
                zIndex={3}
            />
            <DownloadUserDropdown
                value={userId}
                setValue={setUserId}
                zIndex={2}
                userText={userText}
                setUserText={setUserText}
            />
            <DownloadCameraDropdown
                value={cameraId}
                setValue={setCameraId}
                zIndex={1}
                cameraText={cameraText}
                setCameraText={setCameraText}
            />
        </Filters>
    );
}


export default Filter;
